<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EUgPxU/tc-custom/9780830873401.jpg?1696025393498" alt="This image is the cover for the book Becoming a Just Church"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Becoming a Just Church
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>IVP Readers' Choice Award</strong> </p> <p> <strong>Stop outsourcing justice!</strong> </p> <p>Many local churches don't know what to do about justice. We tend to compartmentalize it as merely a strategy for outreach, and we often outsource it to parachurch justice ministries. While these organizations do good work, individual congregations are left disconnected from God's just purposes in the world.</p> <p>Adam Gustine calls the local church to be just and do justice. He provides a theological vision for our identity as a just people, where God's character and the pursuit of shalom infuses every aspect of our congregational DNA. As we grow in becoming just, the church becomes a prophetic alternative to the broken systems of the world and a parable of God's intentions for human flourishing and societal transformation. This renewed vision for the church leads us into cultivating a just life together—in community, discipleship, worship, and more—extending justice out into the world in concrete ways.</p> <p>Let's hold being and doing together, so we can become just, compassionate communities that restore shalom and bring hope to the world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam L. Gustine, Dennis Edwards
      </h2>
      
      <p class="authorDescription body article"><p>Adam L. Gustine leads CovEnterprises, a social enterprise initiative of Love Mercy Do Justice, for the Evangelical Covenant Church. He is also the founder of an enterprise incubator in South Bend, Indiana, dedicated to extending opportunity, restoration, and ownership to the margins. He has pastored multiple churches in a wide variety of contexts and has a doctor of ministry degree from Missio Seminary in Philadelphia, Pennsylvania. He and his wife, Ann, are raising three kids to seek the shalom of their city South Bend.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2aee0e7b